////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const distributionGroupRepository = {
	postDistributionGroup: (filters = {}, queryParams = { page: '0', size: '250', nameDir: 'desc', sort: 'createdDate' }) => ({
		type: ActionsTypes.POST_DISTRIBUTION_GROUP,
		payload: {
			filters,
			queryParams,
		},
	}),
	postDistributionGroupSuccess: (data) => ({
		type: ActionsTypes.POST_DISTRIBUTION_GROUP_SUCCESS,
		payload: {
			data,
		},
	}),
	postDistributionGroupFailure: (error) => ({
		type: ActionsTypes.POST_DISTRIBUTION_GROUP_FAILURE,
		payload: {
			error,
		},
	}),

	postActiveItem: (idItem, query) => ({
		type: ActionsTypes.POST_ACTIVE_ITEM,
		payload: {
			idItem,
			query,
		},
	}),
	postActiveItemSuccess: (data) => ({
		type: ActionsTypes.POST_ACTIVE_ITEM_SUCCESS,
		payload: {
			data,
		},
	}),
	postActiveItemFailure: (error) => ({
		type: ActionsTypes.POST_ACTIVE_ITEM_FAILURE,
		payload: {
			error,
		},
	}),

	postDeleteItem: (idItem, query) => ({
		type: ActionsTypes.POST_DELETE_ITEM,
		payload: {
			idItem,
			query,
		},
	}),
	postDeleteItemSuccess: (data) => ({
		type: ActionsTypes.POST_DELETE_ITEM_SUCCESS,
		payload: {
			data,
		},
	}),
	postDeleteItemFailure: (error) => ({
		type: ActionsTypes.POST_DELETE_ITEM_FAILURE,
		payload: {
			error,
		},
	}),

	getItemDetail: (idItem) => ({
		type: ActionsTypes.GET_ITEM_DETAIL,
		payload: {
			idItem,
		},
	}),
	getItemDetailSuccess: (data) => ({
		type: ActionsTypes.GET_ITEM_DETAIL_SUCCESS,
		payload: {
			data,
		},
	}),
	getItemDetailFailure: (error) => ({
		type: ActionsTypes.GET_ITEM_DETAIL_FAILURE,
		payload: {
			error,
		},
	}),

	setItemId: (id) => ({
		type: ActionsTypes.SET_ITEM_ID,
		payload: {
			id,
		},
	}),
	postDeactivateItem: (id, query) => ({
		type: ActionsTypes.POST_DEACTIVATE_REF_ITEM,
		payload: {
			id,
			query,
		},
	}),
	postDeactivateItemSuccess: (data) => ({
		type: ActionsTypes.POST_DEACTIVATE_REF_ITEM_SUCCESS,
		payload: {
			data,
		},
	}),
	postDeactivateItemFailure: (error) => ({
		type: ActionsTypes.POST_DEACTIVATE_REF_ITEM_FAILURE,
		payload: {
			error,
		},
	}),
	resetDistributionGroup: () => ({
		type: ActionsTypes.RESET_DISTRIBUTION_GROUP,
	}),
}

export default distributionGroupRepository
